export const SPECTRALOOM_URL = "https://spectraloom.app/";

export const SECTIONS = [
  { slug: "articles", it: "Articoli", en: "Articles" },
  { slug: "tutorials", it: "Tutorial", en: "Tutorials" },
  { slug: "videos", it: "Video", en: "Videos" },
  { slug: "case_studies", it: "Studio Lab", en: "Studio Lab" },
];

export const sectionLabel = (slug, lang) => {
  const s = SECTIONS.find((x) => x.slug === slug);
  if (!s) return slug;
  return lang === "IT" ? s.it : s.en;
};

// Pick a localized value from an {it,en} object (with fallbacks). Also tolerates plain strings.
export const localize = (field, lang) => {
  if (field == null) return "";
  if (typeof field === "string") return field;
  const key = lang === "EN" ? "en" : "it";
  return field[key] || field.it || field.en || "";
};

export const UI = {
  IT: {
    heroHeadline: "Il tuo studio di analisi musicale, potenziato dall'AI",
    heroCta: "Prova Spectraloom gratis",
    heroSub: "Guide, tutorial e Studio Lab per produttori, musicisti e sound designer.",
    all: "Tutti",
    readMore: "Leggi di più",
    by: "di",
    noContent: "Nessun contenuto pubblicato in questa sezione.",
    back: "Torna al blog",
    backToApp: "Torna all'app",
    articleDisclaimer: "I testi e ogni contenuto di questo blog sono generati con l'assistenza dell'AI.",
    footerTagline: "Analisi musicale potenziata dall'AI.",
    visit: "Visita Spectraloom",
    aiDisclosure: "I testi e ogni contenuto di questo blog sono generati con l'assistenza dell'AI.",
  },
  EN: {
    heroHeadline: "Your music analysis studio, powered by AI",
    heroCta: "Try Spectraloom free",
    heroSub: "Guides, tutorials and Studio Lab for producers, musicians and sound designers.",
    all: "All",
    readMore: "Read more",
    by: "by",
    noContent: "No published content in this section yet.",
    back: "Back to blog",
    backToApp: "Back to app",
    articleDisclaimer: "The texts and all content on this blog are generated with the assistance of AI.",
    footerTagline: "AI-powered music analysis.",
    visit: "Visit Spectraloom",
    aiDisclosure: "The texts and all content on this blog are generated with the assistance of AI.",
  },
};
